module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/employee-claims/leave/leave.component.css
// module id = ./src/app/hrms/employee-claims/leave/leave.component.css
// module chunks = main